export default function Footer() {
  return (
    <footer className="w-full bg-background-200/70 pt-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 pb-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <a href="#home" className="flex items-center gap-2">
              <span className="grid h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
                <i className="ri-emotion-laugh-line"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">韩国歪歪漫画</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              专供搞笑与无厘头内容，收录沙雕日常、神吐槽、梗图段子，无厘头剧情持续更新，找乐子就上韩国歪歪漫画。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li><a href="#collections" className="hover:text-primary-600">热门合集</a></li>
              <li><a href="#categories" className="hover:text-primary-600">内容分类</a></li>
              <li><a href="#rants" className="hover:text-primary-600">神吐槽</a></li>
              <li><a href="#memes" className="hover:text-primary-600">梗图段子</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950">热门分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li><a href="#categories" className="hover:text-primary-600">沙雕日常</a></li>
              <li><a href="#categories" className="hover:text-primary-600">神吐槽专区</a></li>
              <li><a href="#categories" className="hover:text-primary-600">梗图段子</a></li>
              <li><a href="#categories" className="hover:text-primary-600">无厘头剧场</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i> hello@waiwaicomics.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-refresh-line"></i> 每日更新
              </li>
              <li>
                <a href="#contact" className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700">
                  订阅搞笑合集 <i className="ri-arrow-right-line"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-background-300/60 py-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 韩国歪歪漫画 · 快乐常伴，乐子不断
          </p>
          <div className="flex items-center gap-3 text-foreground-500">
            <a href="#home" className="hover:text-primary-600" aria-label="回到顶部">
              <i className="ri-arrow-up-line text-lg"></i>
            </a>
            <span className="inline-flex items-center gap-1 text-xs">
              <i className="ri-emotion-laugh-line text-primary-500"></i> 找乐子就上歪歪漫画
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}